import React from 'react';
import UnpublishCancelButton from '../atoms/UnpublishCancelButton';
import UnpublishConfirmButton from '../atoms/UnpublishConfirmButton';
import { FooterActions } from '../styles';

interface Props {
  onOk: () => void;
  onCancel: () => void;
}

const UnpublishConfirmFooter: React.FC<Props> = ({ onOk, onCancel }) => (
  <FooterActions>
    <UnpublishCancelButton onClick={onCancel} />
    <UnpublishConfirmButton onClick={onOk} />
  </FooterActions>
);

export default UnpublishConfirmFooter;
